(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-slider-wrapper').forEach(function (wrapper) {
      const slider = wrapper.querySelector('[data-slider]');
      if (!slider) return;

      const slides = Array.from(slider.children);
      const total = slides.length;
      const prevBtn = wrapper.querySelector('.custom-prev');
      const nextBtn = wrapper.querySelector('.custom-next');
      const dotsContainer = wrapper.querySelector('.custom-slider-dots');

      let index = 0;
      let isDragging = false;
      let startX = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID = null;
      const transitionDuration = 600; // ms

      // build dots
      if (dotsContainer && total > 0) {
        dotsContainer.innerHTML = '';
        slides.forEach(function (_, i) {
          const dot = document.createElement('button');
          dot.className = 'dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.setAttribute('role', 'tab');
          dot.dataset.index = i;
          dot.addEventListener('click', function () {
            goToSlide(i);
          });
          dotsContainer.appendChild(dot);
        });
      }

      function updateDots(i) {
        if (!dotsContainer) return;
        Array.from(dotsContainer.children).forEach(function (d) {
          d.classList.toggle('active', Number(d.dataset.index) === i);
        });
      }

      function setSliderPosition() {
        slider.style.transform = 'translateX(' + -index * 100 + '%)';
      }

      function goToSlide(i) {
        index = (i + total) % total;
        // Add smooth transition
        slider.style.transition = 'transform ' + transitionDuration / 1000 + 's cubic-bezier(.22,.9,.34,1)';
        setSliderPosition();
        updateDots(index);
        // remove transition after it ends to allow dragging without jump
        clearTimeout(animationID);
        animationID = setTimeout(function () {
          slider.style.transition = '';
        }, transitionDuration);
      }

      // prev / next
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(index > 0 ? index - 1 : total - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(index < total - 1 ? index + 1 : 0);
        });
      }

      // keyboard support
      wrapper.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') prevBtn && prevBtn.click();
        if (e.key === 'ArrowRight') nextBtn && nextBtn.click();
      });

      // basic touch / drag support (horizontal)
      slider.addEventListener('pointerdown', pointerDown);
      window.addEventListener('pointerup', pointerUp);
      window.addEventListener('pointermove', pointerMove);
      slider.style.touchAction = 'pan-y';

      function pointerDown(event) {
        isDragging = true;
        startX = getPointerX(event);
        slider.style.transition = ''; // cancel transitions while dragging
      }

      function pointerMove(event) {
        if (!isDragging) return;
        const currentX = getPointerX(event);
        const diff = currentX - startX;
        const pct = (diff / wrapper.offsetWidth) * 100;
        slider.style.transform = 'translateX(' + (-index * 100 + pct) + '%)';
      }

      function pointerUp(event) {
        if (!isDragging) return;
        isDragging = false;
        const endX = getPointerX(event);
        const diff = endX - startX;
        const threshold = wrapper.offsetWidth * 0.15;
        if (Math.abs(diff) > threshold) {
          if (diff < 0) {
            // moved left -> next
            goToSlide(index + 1);
          } else {
            goToSlide(index - 1);
          }
        } else {
          goToSlide(index); // snap back
        }
      }

      function getPointerX(e) {
        return e.touches && e.touches[0]
          ? e.touches[0].clientX
          : e.clientX || (e.changedTouches && e.changedTouches[0] && e.changedTouches[0].clientX) || 0;
      }

      // set initial position
      setSliderPosition();
      updateDots(index);

      // optional: autoplay (commented out). To enable, set autoplay = true and interval ms
      /*
    let autoplay = false;
    let autoplayInterval = 5000;
    let autoplayTimer;
    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        goToSlide(index < total - 1 ? index + 1 : 0);
      }, autoplayInterval);
    }
    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }
    wrapper.addEventListener('mouseenter', stopAutoplay);
    wrapper.addEventListener('mouseleave', startAutoplay);
    startAutoplay();
    */
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
